import { Validator } from './validator';
import { ValidField } from '../forms/multiple-contacts-form';

export interface IMultipleContactsValidatorModel {
    amount: number;
    fields: ValidField[];
}

export class MultipleContactsValidator implements Validator {
    async validate(model: IMultipleContactsValidatorModel) {
        if (model.fields.every((x) => x.isValid)) {
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
    }
}
